class UpsellProductForm extends HTMLElement {
  constructor() {
    super();   
   
    this.form = this.querySelector('form');
    // this.form.addEventListener('submit', this.bundleUpsellFormSubmit.bind(this));
    this.cartMini = document.querySelector('cart-mini');
    this.submitBtn = this.querySelector('.submitform');
  }

  bundleUpsellFormSubmit(evt){
    let self = this;
    
    let cartItems = document.querySelector('#cart-mini-items');
    let bundleUpsell = this.closest('cart-bundle-upsell');
    let bundleRegularProduct1 = JSON.parse(document.querySelector('.bundle-upsell__notice').getAttribute('data-bundle-product-1'))[0];
    let bundleRegularProduct2 = JSON.parse(document.querySelector('.bundle-upsell__notice').getAttribute('data-bundle-product-2'))[0];
    let bundleRegularProduct1Id = bundleRegularProduct1.id;
    let bundleRegularProduct2Id = bundleRegularProduct2.id;

    const body = JSON.stringify({
      updates: {
          bundleRegularProduct1Id: 0,
          bundleRegularProduct2Id: 0
      }
  });

    return fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), body })
    .then( (response) => {
        // document.querySelector('cart-mini').setAttribute('data-updating', "render");
        return response.json();
    })
    .catch(e => {
        console.error(e);
        return e;
    });

    // console.log('object');
    // self.onSubmitHandler(evt)
  }
  

  onSubmitHandler(evt) {
    console.log(evt);
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');

    if(this.getAttribute('data-update-button') == "true") {
      submitButton.innerText = "Adding";
    }

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    var serializedForm = window.serializeForm(this.form);
    var formObject = JSON.parse(serializedForm);

    var gcform = this.form.querySelector('#gift-card-message');
    if(gcform != null) {

      formObject['properties'] = {
          "To": this.form.querySelector('#to').value,
          "From": this.form.querySelector('#from').value,
          "Message": this.form.querySelector('#message').value,
        };
    }

    var body = JSON.stringify(formObject);

    fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        document.dispatchEvent(new Event('productAddSuccess'));
        document.dispatchEvent(Events().itemAdded._event(parsedState));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        this.cartMini.setAttribute('data-updating', "updated");
        
        if(this.getAttribute('data-update-button') == "true") {
          submitButton.innerText = "Added";
          
        }else{
          submitButton.removeAttribute('disabled');
        }
        if(this.classList.contains('cart-cross-sell__form')){
          this.closest('cart-mini').scrollTop = 0;
        }
      });
  }

  bundleUpsellSubmit(){
    // Upsell modal product form
    if(this.closest('cart-bundle-upsell')){
      let cartItems = document.querySelector('#cart-mini-items');
      let bundleUpsell = this.closest('cart-bundle-upsell');
      let bundleRegularProduct1 = JSON.parse(document.querySelector('.bundle-upsell__notice').getAttribute('data-bundle-product-1'))[0];
      let bundleRegularProduct2 = JSON.parse(document.querySelector('.bundle-upsell__notice').getAttribute('data-bundle-product-2'))[0];
      let bundleRegularProduct1Id = bundleRegularProduct1.id;
      let bundleRegularProduct2Id = bundleRegularProduct2.id;
      let itemsToRemove = []

      cartItems.querySelectorAll('cart-mini-item').forEach(item => {
        let itemId = item.getAttribute('data-product-id');

        if (itemId == bundleRegularProduct1Id) {
          console.log(bundleRegularProduct1Id);
          itemsToRemove.push(item.dataset.lineNumber)
          document.querySelector('cart-mini-item').closest('cart-mini').updateItem(item.dataset.lineNumber, 0);
        } else if(itemId == bundleRegularProduct2Id) {
          console.log(bundleRegularProduct2Id);
          itemsToRemove.push(item.dataset.lineNumber)
          document.querySelector('cart-mini-item').closest('cart-mini').updateItem(item.dataset.lineNumber, 0);
        }
      });
      // console.log(itemsToRemove);
    }
  }
}

customElements.define('upsell-product-form', UpsellProductForm);
